import { render, staticRenderFns } from "./users-club-events-filter.vue?vue&type=template&id=06be5444"
import script from "./users-club-events-filter.vue?vue&type=script&lang=js"
export * from "./users-club-events-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports